module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "mes"
    }
  }, [_vm._v("Mês")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.mes),
      expression: "dados.mes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "mes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("Janeiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Fevereiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("Março")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("Abril")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Maio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Junho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Julho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("Agosto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("Setembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Outubro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Novembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Dezembro")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ano"
    }
  }, [_vm._v("Ano")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.ano),
      expression: "dados.ano"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "ano", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2020"
    }
  }, [_vm._v("2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2021"
    }
  }, [_vm._v("2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2023"
    }
  }, [_vm._v("2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2024"
    }
  }, [_vm._v("2024")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2025"
    }
  }, [_vm._v("2025")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2026"
    }
  }, [_vm._v("2026")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "form-group btn btn-primary",
    staticStyle: {
      "margin-top": "0.3em"
    },
    on: {
      "click": _vm.gerarRelatorio
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Gerar")])])]), _vm._v(" "), (_vm.showRelatorio) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data.itens), function(item) {
    return _c('tr', {
      key: item.razao,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.total_boletos, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((item.recebido_estabelecimento ? item.recebido_estabelecimento : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((item.servicos_premium ? item.servicos_premium : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((item.repasse_liquido ? item.repasse_liquido : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((item.recebido_premium ? item.recebido_premium : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', {
      class: item.recebido_premium - item.repasse_liquido > 0 ? 'green' : 'red'
    }, [_vm._v(_vm._s(_vm._f("numberFormat")(((item.recebido_premium - item.repasse_liquido) ? item.recebido_premium - item.repasse_liquido : '0'), 2, ',', '.')))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "even"
  }, [_c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.apiData.data.total_boletos, 2, ',', '.')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("numberFormat")((_vm.apiData.data.total_recebido_estabelecimento ? _vm.apiData.data.total_recebido_estabelecimento : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("numberFormat")((_vm.apiData.data.total_servicos_premium ? _vm.apiData.data.total_servicos_premium : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("numberFormat")((_vm.apiData.data.total_repasse_liquido ? _vm.apiData.data.total_repasse_liquido : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("numberFormat")((_vm.apiData.data.total_recebido_premium ? _vm.apiData.data.total_recebido_premium : '0'), 2, ',', '.')))]), _vm._v(" "), _c('td', {
    class: _vm.apiData.data.total_recebido_premium - _vm.apiData.data.total_repasse_liquido > 0 ? 'green' : 'red',
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("numberFormat")(((_vm.apiData.data.total_recebido_premium - _vm.apiData.data.total_repasse_liquido) ? _vm.apiData.data.total_recebido_premium - _vm.apiData.data.total_repasse_liquido : '0'), 2, ',', '.')))])])])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Relatório de Faturamento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Loja")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Repasse Bruto")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Recebido Estab")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Serviços Premium")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Repasse Líquido")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Recebido Premium")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Receita")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d631524"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/financeiro/relatorios/faturamento/index.vue
// module id = 383
// module chunks = 1